import React from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

export default function DashboardLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 dark:text-white transition-colors">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-[240px_1fr] gap-6 mt-6">
          <div className="hidden md:block">
            <Sidebar />
          </div>
          <main className="min-h-[60vh]">{children}</main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
